/* Product card image gallery: arrow + dot navigation across all product images. */
(() => {
  function setActive(gallery, index) {
    const slides = gallery.querySelectorAll('.ref-card-gallery__slide');
    const dots = gallery.querySelectorAll('.ref-card-gallery__dot');
    if (!slides.length) return;

    const count = slides.length;
    const nextIndex = ((index % count) + count) % count;

    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === nextIndex));
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === nextIndex));
    gallery.dataset.activeIndex = String(nextIndex);
  }

  function currentIndex(gallery) {
    return parseInt(gallery.dataset.activeIndex || '0', 10) || 0;
  }

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('.ref-card-gallery__arrow');
    if (arrow) {
      const gallery = arrow.closest('[data-ref-card-gallery]');
      if (!gallery) return;
      event.preventDefault();
      event.stopPropagation();
      const direction = arrow.classList.contains('ref-card-gallery__arrow--next') ? 1 : -1;
      setActive(gallery, currentIndex(gallery) + direction);
      return;
    }

    const dot = event.target.closest('.ref-card-gallery__dot');
    if (dot) {
      const gallery = dot.closest('[data-ref-card-gallery]');
      if (!gallery) return;
      const dots = Array.from(gallery.querySelectorAll('.ref-card-gallery__dot'));
      const index = dots.indexOf(dot);
      if (index === -1) return;
      event.preventDefault();
      event.stopPropagation();
      setActive(gallery, index);
    }
  });
})();
